export default __webpack_public_path__ + "static/media/close.b716fcb6.svg";